import { useMutation, useQueryClient } from '@tanstack/react-query';
import { IBatchConfig } from '../../utils/types';
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';
import { toast } from 'react-toastify';

export const useUpdateBatchConfigs = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: Partial<IBatchConfig>) => {
      const res = await apiClient.put(ENDPOINTS.BATCH_CONFIGS.UPDATE, payload);
      return res.data;
    },
    onSuccess: (data) => {
      toast.success(data?.message || 'Batch configs updated successfully!');
      queryClient.invalidateQueries({ queryKey: ['get_batch_configs'] });
    },
    onError: (err: any) => {
      toast.error(err?.response?.data?.message || 'Failed to update batch configs');
    },
  });
};
